import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from 'react';
import { cn } from '../lib/cn.js';
const TONE_BG = {
    accent: 'color-mix(in oklab, var(--color-accent) 22%, transparent)',
    sage: 'color-mix(in oklab, var(--color-sage) 22%, transparent)',
    rose: 'color-mix(in oklab, var(--color-rose) 22%, transparent)',
    steel: 'color-mix(in oklab, var(--color-steel) 22%, transparent)',
    neutral: 'color-mix(in oklab, var(--color-ink-muted) 18%, transparent)',
};
const TONE_INK = {
    accent: 'var(--color-accent-bright)',
    sage: 'var(--color-sage)',
    rose: 'var(--color-rose)',
    steel: 'var(--color-steel)',
    neutral: 'var(--color-ink-secondary)',
};
const DOW_LETTERS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
export function CalendarMini({ monthLabel, startDow, days, highlights = {}, eventCount, today, className, onDayClick, }) {
    // Clamp the leading offset so a malformed value can't blow up the grid.
    const lead = Math.max(0, Math.min(6, startDow));
    const cells = [];
    for (let i = 0; i < lead; i += 1)
        cells.push(null);
    for (let d = 1; d <= days; d += 1)
        cells.push(d);
    return (_jsxs("div", { className: cn('w-full', className), children: [_jsxs("div", { className: "mb-3 flex items-center justify-between", children: [_jsx("span", { className: "font-mono text-xs uppercase tracking-[0.14em] text-[var(--color-ink)]", children: monthLabel }), typeof eventCount === 'number' && (_jsxs("span", { className: "font-mono text-2xs uppercase tracking-[0.12em] text-[var(--color-ink-muted)]", children: [eventCount, " ", eventCount === 1 ? 'event' : 'events'] }))] }), _jsxs("div", { className: "grid grid-cols-7 gap-1", children: [DOW_LETTERS.map((d, i) => (_jsx("div", { "aria-hidden": true, className: "text-center font-mono text-[9px] uppercase tracking-[0.1em] text-[var(--color-ink-muted)]", children: d }, `dow-${i}`))), cells.map((d, i) => {
                        if (d === null) {
                            return _jsx("div", { "aria-hidden": true }, `pad-${i}`);
                        }
                        const tone = highlights[d] ?? null;
                        const isToday = today === d;
                        const Tag = onDayClick ? 'button' : 'div';
                        return (_jsx(Tag, { ...(Tag === 'button'
                                ? {
                                    type: 'button',
                                    onClick: () => onDayClick?.(d, tone),
                                    'aria-label': `${monthLabel} ${d}${tone ? ` — ${tone} highlight` : ''}${isToday ? ' (today)' : ''}`,
                                }
                                : {}), className: cn('flex aspect-square items-center justify-center rounded-[5px] border text-center font-mono text-[10px] transition-colors', isToday ? 'border-[var(--color-accent)]' : 'border-transparent', Tag === 'button' && 'hover:border-[var(--color-line-strong)]'), style: {
                                background: tone ? TONE_BG[tone] : 'transparent',
                                color: tone ? TONE_INK[tone] : 'var(--color-ink-secondary)',
                            }, children: d }, d));
                    })] })] }));
}
